var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"width":"100%"}},[(_vm.title)?[_c('div',{staticClass:"j-flex",staticStyle:{"width":"120px"}},[_c('img',{staticStyle:{"width":"120px","border-radius":"4px"},attrs:{"src":_vm.value,"alt":""}})]),_c('div',{staticClass:"ml-10",staticStyle:{"max-width":"250px"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])]:[_c('div',{staticClass:"j-flex",staticStyle:{"width":"100%"}},[_c('div',{style:({
            'border-radius': _vm.border + 'px',
            'background-image': 'url(' + _vm.value + ')',
            width: _vm.width + 'px',
            height: _vm.height + 'px',
            'background-position': 'center center',
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
          })})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }